import { h, Component, Fragment } from 'preact'
import tdlib from '../../utils/tdlib'
import { Input } from '../../UI/Input'
import { ERROR_CODES } from '../../constants/errorCodes'
import AuthStep from '../AuthStep'
import s from './PasswordForm.css'
import { Button } from '../../UI/Button'
import cn from 'classnames'

interface iState {
  isLoading: boolean
  errorCode: string | null,
  password: string
  passwordVisibility: boolean
}

class PasswordForm extends Component<{}, iState> {
  state = {
    isLoading: false,
    errorCode: null,
    password: '',
    passwordVisibility: false
  }

  togglePasswordView = () => {
    const { passwordVisibility } = this.state

    this.setState({
      passwordVisibility: !passwordVisibility
    })
  }

  onChangePassword = (e: Event) => {
    const { value: password } = e.target as HTMLInputElement

    this.setState({
      errorCode: null,
      password
    })
  }

  submitForm = async (e: Event) => {
    e.preventDefault()
    const { password } = this.state

    this.setState({
      isLoading: true
    })

    await tdlib
      .send({
        '@type': 'checkAuthenticationPassword',
        password
      })
      .then((resp) => {})
      .catch((err) => {
        const errorCode = (
          ERROR_CODES[err.message as 'PHONE_CODE_INVALID'] ||
          err.message
        )

        this.setState({
          isLoading: false,
          errorCode
        })
      })
  }

  render () {
    const {
      isLoading,
      passwordVisibility,
      password,
      errorCode
    } = this.state

    const fieldType = passwordVisibility ? 'text' : 'password'
    const isPasswordType = fieldType === 'password'

    return (
      <AuthStep
        image={(
          <div className={cn(s.PasswordForm__icon, {
            [s.PasswordForm__icon_visible]: passwordVisibility
          })}/>
        )}
        title="Enter as Password"
        text={(
          `Your account is protected with
          an additional password.`
        )}
      >
        <form
          className={s.PasswordForm}
          onSubmit={this.submitForm}
        >
          <div className={s.PasswordForm__field}>
            <Input
              type={fieldType}
              label={errorCode || 'Password'}
              onInput={this.onChangePassword}
              value={password}
              name="password"
              invalid={!!errorCode}
              autoFocus
            />

            <button
              type="button"
              className={cn(s.PasswordForm__passwordSwitcher, {
                [s.PasswordForm__passwordSwitcher_visible]: passwordVisibility
              })}
              onClick={this.togglePasswordView}
            />
          </div>

          {password && (
            <Button
              className={s.PasswordForm__submit}
              isLoading={isLoading}
            >
              Next
            </Button>
          )}
        </form>
      </AuthStep>
    )
  }
}

export default PasswordForm
